import { faCaretDown, faCaretUp } from '@fortawesome/fontawesome-free-solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Block, P, Select } from '../../../../components/basic'
import { Black, LABELS } from '../../../../constants'

export const SelectWithCustomSizingOption = ({
    displayFlag,
    elementKey,
    handleChooseSelect,
    handleSelectChange,
    handleTextElementClick,
    mode,
    options,
    required,
    shouldDisplayText,
    title,
    toggleFields,
    value
}) => {

    const toggleIcon = toggleFields
        ? <FontAwesomeIcon icon={faCaretUp} />
        : <FontAwesomeIcon icon={faCaretDown} />

    const textElementOptions = {
        color: Black,
        cursor: "pointer",
        decoration: "underline",
        onClick: handleTextElementClick,
        size: "18px"
    }

    return (
        <Block margin="20px 0 0 0" key={elementKey}>
            {
                shouldDisplayText ?
                    <Block margin="0 0 20px">
                        <P {...textElementOptions}>
                            {LABELS.NEED_CUSTOM_SIZING}
                            {toggleIcon}
                        </P>
                    </Block>
                    : ""
            }
            <Select
                title={title}
                legend={title}
                required={required}
                options={options}
                value={value}
                onChange={handleSelectChange}
                displayFlag={displayFlag}
                mode={mode}
                chooseSelect={handleChooseSelect}
            />
        </Block>
    )
}